import { workspaceModuleApi } from '../api';
import { useState } from 'react';
import { FetchStatus } from 'types/api';
import { isAxiosError } from 'axios';
import { QAItem } from 'types/api.d';

export const usePostQa = () => {
  const [status, setPostStatus] = useState<FetchStatus>('idle');
  const [error, setError] = useState<string | null>(null);
  const [item, setItem] = useState<QAItem | null>(null);

  const postQa = async (data: {
    question: string;
    answer: string;
    category: number;
    department: number;
  }) => {
    try {
      setPostStatus('loading');
      const item = await workspaceModuleApi.addQaItem(data);
      setItem(item);
      setPostStatus('success');
    } catch (error) {
      if (isAxiosError(error)) {
        setError(error.response?.data.detail || error.message);
      } else {
        setError('An error occurred');
      }
      setPostStatus('failed');
    }
  };

  return { item, status, error, postQa, setPostStatus };
};
